<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-main">
        <div class="footer-brand">
          <div class="footer-logo">
            <span class="logo-text">{{ siteConfig.sitename }}</span>
          </div>
          <p class="footer-desc">{{ siteConfig.description }}</p>
        </div>

        <div class="footer-nav-group">
          <div class="footer-nav-section">
            <h4 class="footer-nav-title">联系我们</h4>
            <ul class="footer-nav-list">
              <li v-if="contactInfo.qun"><a :href="contactInfo.qun" target="_blank">加入QQ群</a></li>
              <li v-if="contactInfo.qq"><a :href="'mailto:' + contactInfo.qq + '@qq.com'">邮箱: {{ contactInfo.qq }}@qq.com</a></li>
              <li v-if="contactInfo.kefulink"><a :href="contactInfo.kefulink" target="_blank">在线客服</a></li>
              <li v-else-if="contactInfo.qq"><a :href="'http://wpa.qq.com/msgrd?v=3&uin=' + contactInfo.qq + '&site=qq&menu=yes'" target="_blank">在线客服</a></li>
            </ul>
          </div>

          <div v-if="friendLinks.length > 0" class="footer-nav-section">
            <h4 class="footer-nav-title">友情链接</h4>
            <ul class="footer-nav-list">
              <li v-for="link in friendLinks" :key="link.url">
                <a :href="link.url" target="_blank">{{ link.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-copyright">
          &copy; {{ currentYear }} {{ siteConfig.sitename }} | 版本: V{{ siteConfig.version }}
        </div>
        <div v-if="contactInfo.icp || contactInfo.policeReg || contactInfo.operator" class="footer-legal">
          <span v-if="contactInfo.icp">
            <a :href="'https://beian.miit.gov.cn/'" target="_blank">{{ contactInfo.icp }}</a>
          </span>
          <span v-if="contactInfo.icp && contactInfo.policeReg" class="divider">·</span>
          <span v-if="contactInfo.policeReg">
            <a :href="'https://beian.mps.gov.cn/'" target="_blank">{{ contactInfo.policeReg }}</a>
          </span>
        </div>
        <div class="footer-legal">
          <a href="#">隐私政策</a>
          <span class="divider">·</span>
          <a href="#">服务条款</a>
          <span class="divider">·</span>
          <a href="#">免责声明</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { siteConfig, contactInfo, friendLinks } from '../data/data.js'

const currentYear = new Date().getFullYear()
</script>
